
import { getOneTimeNoRideData, getOneTimeNoRideFilters } from '../api.js'

import settings from '../settings.js'
import pageApiData from '../utils/pageApiData.js'

const [ _getOneTimeNoRideDataFromServer, _getOneTimeNoRideData, _getOneTimeNoRideDataSync ] = pageApiData.createFunctions(getOneTimeNoRideData, 'Unable to get one time no ride data from server.')
const [ _getOneTimeNoRideFiltersFromServer, _getOneTimeNoRideFilters, _getOneTimeNoRideFiltersSync ] = pageApiData.createFunctions(getOneTimeNoRideFilters, 'Unable to get one time no ride filters from server.')

function getNumPerPage() {
  return settings.oneTimeNoRideList.numPerPage
}

function getCurrentPage() {
  return settings.oneTimeNoRideList.currentPage
}

function setCurrentPage(pageNumber) {
  settings.oneTimeNoRideList.currentPage = pageNumber
}

function _init() {
  // do nothing
}

_init()

export default {
  getOneTimeNoRideDataFromServer: _getOneTimeNoRideDataFromServer,
  getOneTimeNoRideData: _getOneTimeNoRideData,
  getOneTimeNoRideDataSync: _getOneTimeNoRideDataSync,
  getOneTimeNoRideFiltersFromServer: _getOneTimeNoRideFiltersFromServer,
  getOneTimeNoRideFilters: _getOneTimeNoRideFilters,
  getOneTimeNoRideFiltersSync: _getOneTimeNoRideFiltersSync,

  getNumPerPage: getNumPerPage,
  getCurrentPage: getCurrentPage,
  setCurrentPage: setCurrentPage,
}
